// extracted by mini-css-extract-plugin
module.exports = {"inquiriesReceivedTableShort":"inquiriesReceived_inquiriesReceivedTableShort__rq404","inquiriesReceivedTableLarge":"inquiriesReceived_inquiriesReceivedTableLarge___R4lh"};